import { useCallback } from 'react';

const cleanOrder = (order) => order;

const cleanTransaction = (transaction) => {
  const result = {};

  if (transaction.id) result.id = transaction.id;
  if (transaction.language) result.language = transaction.language;
  if (transaction.state) result.state = transaction.state;

  return result;
};

const cleanPaymentPlan = (paymentPlan) => paymentPlan;

const useSendAnalyticsEvent = () => {
  const sendEvent = useCallback((type, _data = {}) => {
    const data = { ..._data };

    if (data.order) {
      data.order = cleanOrder(data.order);
    }
    if (data.transaction) {
      data.checkout = cleanTransaction(data.transaction);
      delete data.transaction;
    }
    if (data.selectedPaymentPlan) {
      data.paymentPlan = cleanPaymentPlan(data.selectedPaymentPlan);
      delete data.selectedPaymentPlan;
    }

    const event = new CustomEvent(type, { detail: data });
    document.dispatchEvent(event);
  }, []);

  return sendEvent;
};

export default useSendAnalyticsEvent;
